import {CLEnum} from 'common/src/modules/enums/enums.types';

export interface MacroOptionalValues {
  name: string;
  value: string;
  description?: string;
}

export interface MacroItem {
  name: string;
  type?: number;
  value: string;
  description?: string;
  taxonomyKey?: string;
  optionalOperators?: number[];
  optionalValues?: MacroOptionalValues[];
  order?: number;
  shouldQueryOptionalValues?: boolean;
  strictOptionalValues?: boolean;
}

export enum MacroItemTypeValue {
  NA = 0,
  ImageUrl = 10,
  ImageUrlList = 15,
  VideoUrl = 17,
  Text = 20,
  TextList = 25,
  Numeric = 30,
  Condition = 40,
  Color = 50,
  ClickUrl = 60,
  Date = 70,
  DateList = 75,
  DateRange = 80,
}

export enum MacroItemType {
  NA = 'N/A',
  ImageUrl = 'Image',
  ImageUrlList = 'Image List',
  VideoUrl = 'Video',
  Text = 'Text',
  TextList = 'Text List',
  Numeric = 'Number',
  Condition = 'Condition',
  Color = 'Color',
  ClickUrl = 'Page',
  Date = 'Date',
  DateList = 'Date List',
  DateRange = 'Date Range',
  Subtitles = 'Subtitles',
  Font = 'Font',
}

export interface RemoteDynamicLandingPageMacros {
  Key: number;
  Value: RemoteDynamicLandingPageMacrosValue[];
}

export interface RemoteDynamicLandingPageMacrosValue {
  name: string;
  optionalOperators: number[];
  optionalValues: MacroOptionalValues[];
  type: number;
  value: string;
}

export interface DynamicLandingPageMacros {
  type: CLEnum;
  macros: MacroItem[];
}

export enum MacroType {
  LandingPage = 'LandingPagesAnd3rdPartyTags',
  Creative = 'creative',
  CreativeForSocial = 'CreativeForSocial ',
}
